// import React, { useState } from "react";
// import { Modal, Button } from "react-bootstrap";
// import "./History_Vendor_Rate_Btn_Modal.css";
// import ReactStars from "react-rating-stars-component";

// const History_Vendor_Rate_Btn_Modal = ({
//   show,
//   handleClose,
//   modalName,
//   modalImg,
// }) => {
//   const [remark, setRemark] = useState("");

//   const ratingChanged = (newRating) => {
//     console.log(newRating);
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleClose}
//       centered
//       className="rating-history-modal"
//     >
//       <Modal.Body className="p-0">
//         <div className="rating-history-card">
//           <div className="rating-history-content">
//             <div className="rating-history-thumb">
//               <img
//                 src={modalImg || "/assets/images/vendors/vendor3.png"}
//                 alt="vendor"
//                 className="rating-history-img"
//               />
//             </div>
//             <div className="rating-history-body">
//               <div className="rating-history-info-row">
//                 <span className="rating-history-label">Vendor:</span>
//                 <span className="rating-history-value">Abhisheks Woods</span>
//               </div>
//               <div className="rating-history-info-row">
//                 <span className="rating-history-label">Date:</span>
//                 <span className="rating-history-value">12 July 2025</span>
//               </div>
//               <div className="rating-history-info-row">
//                 <span className="rating-history-label">Time:</span>
//                 <span className="rating-history-value">12.40PM</span>
//               </div>
//             </div>
//           </div>

//           <div className="rating-history-stars-container">
//             <div className="rating-history-stars-box">
//               <ReactStars
//                 count={5}
//                 onChange={ratingChanged}
//                 size={24}
//                 activeColor="#ffd700"
//               />
//             </div>
//           </div>

//           <div className="rating-history-remark-container px-3 mb-3">
//             <label className="rating-history-remark-label mb-1">Remarks:</label>
//             <textarea
//               className="form-control rating-history-textarea"
//               rows="2"
//               placeholder=""
//               value={remark}
//               onChange={(e) => setRemark(e.target.value)}
//             ></textarea>
//           </div>
//         </div>

//         <div className="text-center mt-2 pb-3">
//           <Button
//             className="rating-history-submit-btn"
//             onClick={() => {
//               console.log("Remark submitted:", remark);
//               handleClose();
//             }}
//           >
//             Submit
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default History_Vendor_Rate_Btn_Modal;

import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import "./History_Vendor_Rate_Btn_Modal.css";

// IMPORT SUCCESS MODAL: Change this import style if you get an error
import Account_Created_Modal from "../../../login/account-created-modal/Account_Created_Modal";

const History_Vendor_Rate_Btn_Modal = ({
  show,
  handleClose,
  modalName,
  modalImg,
}) => {
  const [remark, setRemark] = useState("");
  const [rating, setRating] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);

  const ratingChanged = (newRating) => {
    setRating(newRating);
  };

  const handleSubmit = () => {
    console.log("Remark submitted:", remark, "Rating:", rating);
    
    // 1. Close the vendor rating modal
    handleClose();
    
    // 2. Open the success modal
    setShowSuccess(true);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="rating-history-modal"
      >
        <Modal.Body className="p-0">
          <div className="rating-history-card">
            <div className="rating-history-content">
              <div className="rating-history-thumb">
                <img
                  src={modalImg || "/assets/images/vendors/vendor3.png"}
                  alt="vendor"
                  className="rating-history-img"
                />
              </div>
              <div className="rating-history-body">
                <div className="rating-history-info-row">
                  <span className="rating-history-label">Vendor:</span>
                  <span className="rating-history-value">{modalName || "Abhisheks Woods"}</span>
                </div>
                <div className="rating-history-info-row">
                  <span className="rating-history-label">Date:</span>
                  <span className="rating-history-value">12 July 2025</span>
                </div>
                <div className="rating-history-info-row">
                  <span className="rating-history-label">Time:</span>
                  <span className="rating-history-value">12.40PM</span>
                </div>
              </div>
            </div>

            <div className="rating-history-stars-container">
              <div className="rating-history-stars-box">
                <ReactStars
                  count={5}
                  onChange={ratingChanged}
                  size={24}
                  activeColor="#ffd700"
                />
              </div>
            </div>

            <div className="rating-history-remark-container px-3 mb-3">
              <label className="rating-history-remark-label mb-1">Remarks:</label>
              <textarea
                className="form-control rating-history-textarea"
                rows="2"
                placeholder=""
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div className="text-center mt-2 pb-3">
            <Button
              className="rating-history-submit-btn"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>

    
      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Review Submitted Successfully!"
      />
    </>
  );
};

export default History_Vendor_Rate_Btn_Modal;
